module.exports = __webpack_public_path__ + "static/media/screen-projet1.5ec22317.png";